export default {
  setSearchForm(state, data) {
    state.searchForm[data.prop] = data.value
  },
  setWholeSearchForm(state, data) {
    state.searchForm = data
  },
}
